<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>MT & Broadcast Data</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>From Date</u></label>
        <input type="date" [(ngModel)]="filterable.fromDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>To Date</u></label>
        <input type="date" [(ngModel)]="filterable.toDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for="gotoShortCode"><u>Goto ShortCode</u></label>
        <ng-select [items]="allShortCodes" bindLabel="scView" placeholder="Goto ShortCode" [(ngModel)]="targetShortCode" class="form-control" (ngModelChange)="gotoTargetShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeSource($event)">
          <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country" (ngModelChange)="changeCountry($event)">
          <option *ngFor="let country of countryList | keyvalue" [value]="country.value">{{country.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator" (ngModelChange)="changeOperator($event)">
          <option value=null selected>- select operator-</option>
          <option *ngFor="let op of operatorList | keyvalue" [ngValue]="op.key">{{op.key}}</option>
        </select>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <label for=""><u>Filter by Short Code</u></label>
        <ng-select [items]="shortCodeList" (clear)="onClear()" placeholder="Select short code" [(ngModel)]="filterable.shortCode" class="form-control" (ngModelChange)="changeShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Keyword</u></label>
        <select [(ngModel)]="filterable.keyword" class="form-control" placeholder="Keyword">
          <option value=null selected>-select keyword-</option>
          <option *ngFor="let kw of keywordList" [ngValue]="kw">{{kw}}</option>
        </select>
      </div>
      <div class="col">
          <label for=""><u>Filter by Event Type</u></label>
          <select [(ngModel)]="filterable.type" class="form-control" placeholder="">
            <option value="" selected>-select type-</option>
            <option *ngFor="let typ of typeList | keyvalue" [value]="typ.key">{{typ.value}}</option>
          </select>
        </div>
      <div class="col">
        <label for=""><u>Filter by State</u></label>
        <select [(ngModel)]="filterable.state" class="form-control" placeholder="">
          <option value="" selected>-select state-</option>
          <option *ngFor="let stat of stateList | keyvalue" [value]="stat.key">{{stat.value}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Postback State</u></label>
        <select [(ngModel)]="filterable.panOutState" class="form-control" placeholder="">
          <option value="" selected>-select status-</option>
          <option *ngFor="let pan of panOutStateList | keyvalue" [value]="pan.key">{{pan.value}}</option>
        </select>
      </div>
      <div class="col">
          <label for=""><u>Filter by Phone</u></label>
          <input type="text" [(ngModel)]="filterable.phone" class="form-control" placeholder="enter phone" />
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
  <div class="col-10 text-right align-self-end">
    <button class="btn btn-danger btn-sm mr-2" (click)="clear()">Clear</button>
    <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
  </div>
  <!-- <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <label for=""><u>Go to page </u> <span class="small">(Max: {{maxPageSize}})</span></label>
    <input type="number" class="form-control form-control-sm" placeholder="Page" [(ngModel)]="goToPage" max="{{maxPageSize}}">
  </div>
  <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <button (click)="setPage(goToPage)" class="btn btn-sm btn-outline-primary">Go</button>
  </div> -->


</div>
<!-- <div class="table-responsive"> -->
<table id="mtList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>ID(MsgId/RequestId)<br>CreatedAt</th>
      <th>ShortCode</th>
      <th>Keyword<br>(ServiceId)</th>
      <th>Operator<br>(OperatorId)</th>
      <th>Phone</th>
      <th>Event Type</th>
      <th>Charge</th>
      <th>Reference</th>
      <th>Current State</th>
      <th>MT Content</th>
      <th>MT Msg(Type,Content,At,Result)</th>
      <th>Export to DN LOG</th>
      <th>Subscriber Data</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="15">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="15">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let mt of mtLogs; index as i;">
      <td class="text-left">
        <span class="font-italic font-weight-bold">ID:</span> {{mt.id}} <br>
        <span class="font-italic font-weight-bold">MsgId:</span> {{mt.msgId}}<br>
        <span class="font-italic font-weight-bold">CreatedAt:</span> {{mt.createdAtView}}
      </td>
      <td>{{mt.shortCode}}</td>
      <td>{{mt.keyword}} <span *ngIf="mt.productId"> <br> ({{mt.productId}})</span></td>
      <td>{{mt.operator}}<span *ngIf="mt.operatorId"> <br> ({{mt.operatorId}})</span></td>
      <td>{{mt.phone}}</td>
      <td>{{mt.eventTypeView}}</td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">Price:</span>  <span class="text-warning">{{mt.price}}{{mt.currency}}</span><br>
        <span class="font-italic font-weight-bold">FallbackTimes:</span>{{mt.fallbackTimes}} <br>
        <span class="font-italic font-weight-bold">KeywordId:</span>{{mt.kid}}
       </td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">Affiliate:</span>  {{mt.affiliate}} <br>
        <span class="font-italic font-weight-bold">ClickId:</span>  {{mt.clickId}} <br>
        <span class="font-italic font-weight-bold">Ref:</span>  {{mt.reference}} <br>
        <span class="font-italic font-weight-bold">Channel:</span>  {{mt.channelView}}
       </td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">State:</span> {{mt.stateView}}<br>
        <span class="font-italic font-weight-bold">Result:</span> {{mt.errorMsg}}</td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">Content:</span> {{mt.content}}<br>
        <span class="font-italic font-weight-bold">Content Ref:</span> {{mt.contentRef}}</td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">Type:</span> {{mt.msgTypeView}}<br>
        <span class="font-italic font-weight-bold">Content:</span> {{mt.msgContent}}<br>
        <span class="font-italic font-weight-bold">At:</span> {{mt.msgProccessAtView}}<br>
        <span class="font-italic font-weight-bold">Result:</span> {{mt.msgErrorMsg}}</td>
      <td>{{mt.panOutStateView}}</td>
      <td class="text-left"><span class="font-italic font-weight-bold">Lang:</span> {{mt.lang}}<br>
        <span class="font-italic font-weight-bold">SubMoId:</span> {{mt.subMoId}}<br>
        <span class="font-italic font-weight-bold">SubscriberId:</span> {{mt.subscriptionId}}<br>
        <span class="font-italic font-weight-bold">SubAt:</span> {{mt.subscriptionAtView}}</td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="15" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
      </td>
    </tr>
  </tfoot>
</table>

